/**
 * @fileoverview gRPC-Web generated client stub for admpb
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_type_date_pb = require('../../google/type/date_pb.js')
const proto = {};
proto.admpb = require('./systemnumber_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.admpb.SystemNumberServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.admpb.SystemNumberServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.admpb.ReadSystemNumberRequest,
 *   !proto.admpb.ReadSystemNumberResponse>}
 */
const methodDescriptor_SystemNumberService_ReadSystemNumber = new grpc.web.MethodDescriptor(
  '/admpb.SystemNumberService/ReadSystemNumber',
  grpc.web.MethodType.UNARY,
  proto.admpb.ReadSystemNumberRequest,
  proto.admpb.ReadSystemNumberResponse,
  /**
   * @param {!proto.admpb.ReadSystemNumberRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.ReadSystemNumberResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.admpb.ReadSystemNumberRequest,
 *   !proto.admpb.ReadSystemNumberResponse>}
 */
const methodInfo_SystemNumberService_ReadSystemNumber = new grpc.web.AbstractClientBase.MethodInfo(
  proto.admpb.ReadSystemNumberResponse,
  /**
   * @param {!proto.admpb.ReadSystemNumberRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.ReadSystemNumberResponse.deserializeBinary
);


/**
 * @param {!proto.admpb.ReadSystemNumberRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.admpb.ReadSystemNumberResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.admpb.ReadSystemNumberResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.admpb.SystemNumberServiceClient.prototype.readSystemNumber =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/admpb.SystemNumberService/ReadSystemNumber',
      request,
      metadata || {},
      methodDescriptor_SystemNumberService_ReadSystemNumber,
      callback);
};


/**
 * @param {!proto.admpb.ReadSystemNumberRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.admpb.ReadSystemNumberResponse>}
 *     A native promise that resolves to the response
 */
proto.admpb.SystemNumberServicePromiseClient.prototype.readSystemNumber =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/admpb.SystemNumberService/ReadSystemNumber',
      request,
      metadata || {},
      methodDescriptor_SystemNumberService_ReadSystemNumber);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.admpb.SystemNumber,
 *   !proto.admpb.ListSystemNumberResponse>}
 */
const methodDescriptor_SystemNumberService_ListSystemNumber = new grpc.web.MethodDescriptor(
  '/admpb.SystemNumberService/ListSystemNumber',
  grpc.web.MethodType.UNARY,
  proto.admpb.SystemNumber,
  proto.admpb.ListSystemNumberResponse,
  /**
   * @param {!proto.admpb.SystemNumber} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.ListSystemNumberResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.admpb.SystemNumber,
 *   !proto.admpb.ListSystemNumberResponse>}
 */
const methodInfo_SystemNumberService_ListSystemNumber = new grpc.web.AbstractClientBase.MethodInfo(
  proto.admpb.ListSystemNumberResponse,
  /**
   * @param {!proto.admpb.SystemNumber} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.ListSystemNumberResponse.deserializeBinary
);


/**
 * @param {!proto.admpb.SystemNumber} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.admpb.ListSystemNumberResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.admpb.ListSystemNumberResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.admpb.SystemNumberServiceClient.prototype.listSystemNumber =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/admpb.SystemNumberService/ListSystemNumber',
      request,
      metadata || {},
      methodDescriptor_SystemNumberService_ListSystemNumber,
      callback);
};


/**
 * @param {!proto.admpb.SystemNumber} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.admpb.ListSystemNumberResponse>}
 *     A native promise that resolves to the response
 */
proto.admpb.SystemNumberServicePromiseClient.prototype.listSystemNumber =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/admpb.SystemNumberService/ListSystemNumber',
      request,
      metadata || {},
      methodDescriptor_SystemNumberService_ListSystemNumber);
};


module.exports = proto.admpb;

